<template>
  <div><GrBrowser /></div>
</template>


<script setup>
import GrBrowser from "@/components/gr/GrBrowser.vue";
import { useAppStore } from "@/store/app-store";

const appStore = useAppStore();
appStore.drawerExpanded = true;
</script>
